// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"49b3985d","707":"381f8b96","729":"496027ef"}[chunkId] + ".js";
};